<div class="ia-reorder-controls">
  <div class="ia-reorder-controls__toolbar">
    <div class="ia-reorder-controls__rule">
      <span class="ia-reorder-controls__label">Default rule</span>
      <button type="button" class="ia-reorder-controls__help" aria-label="About default rules"
        ngbTooltip="Choose a default rule. Item rules stay in place unless you select All items.">?</button>
      <div ngbDropdown #ruleMenu="ngbDropdown">
        <button type="button" class="btn btn-outline-secondary" ngbDropdownToggle
          [attr.aria-label]="'Default reorder rule: ' + (selectedRule?.name || 'Custom settings')">
          {{ selectedRule?.name || 'Custom settings' }}
        </button>
        <div ngbDropdownMenu>
          <button type="button" ngbDropdownItem *ngFor="let rule of rules"
            (click)="ruleChange.emit(rule); ruleMenu.close()">{{ rule.name || 'Custom' }}</button>
        </div>
      </div>
      <button type="button" class="btn btn-outline-secondary" (click)="ruleCreate.emit()">New rule</button>
    </div>
    <div class="ia-reorder-controls__actions">
      <button type="button" class="btn btn-outline-secondary" (click)="settingsOpen.emit()">More settings</button>
      <button type="button" class="btn btn-outline-secondary" [attr.aria-expanded]="expanded" [attr.aria-controls]="optionsId"
        (click)="expandedChange.emit(!expanded)">{{ expanded ? 'Fewer options' : 'More options' }}</button>
      <button type="button" class="btn btn-brand" [disabled]="!ruleChanged" (click)="applyUpdates.emit()">Apply updates</button>
    </div>
  </div>
  <div class="ia-reorder-controls__ranges">
    <section>
      <div class="ia-reorder-controls__range-label"><h3>Order supply for</h3>
        <button type="button" class="ia-reorder-controls__help" aria-label="About stock coverage"
          ngbTooltip="Choose how many days or months of stock to order.">?</button></div>
      <ng-content select="[order-for-compact]"></ng-content>
      <ng-content select="[order-for-expanded]"></ng-content>
    </section>
    <section>
      <div class="ia-reorder-controls__range-label"><h3>Based on sales from</h3>
        <button type="button" class="ia-reorder-controls__help" aria-label="About the sales period"
          ngbTooltip="Choose the sales period used to calculate reorder quantities.">?</button></div>
      <ng-content select="[based-on-compact]"></ng-content>
      <ng-content select="[based-on-expanded]"></ng-content>
    </section>
  </div>
  <div *ngIf="expanded" [id]="optionsId" class="ia-reorder-controls__options">
    <fieldset class="ia-reorder-controls__scope">
      <legend>Apply rule to</legend>
      <label><input type="radio" [name]="optionsId + '-scope'" [checked]="!applyToAll"
        (change)="applyScopeChange.emit(false)"> Items without a rule</label>
      <label><input type="radio" [name]="optionsId + '-scope'" [checked]="applyToAll"
        (change)="applyScopeChange.emit(true)"> All items</label>
    </fieldset>
    <div class="ia-reorder-controls__summary" *ngIf="summary">
      <h3>Calculation settings</h3>
      <div class="ia-reorder-controls__flags">
        <span *ngFor="let flag of calculationFlags" class="ia-reorder-controls__flag" [class.is-on]="summary[flag.key]">
          <span aria-hidden="true">{{ summary[flag.key] ? '✓' : '–' }}</span> {{ flag.label }}
          <span class="sr-only">{{ summary[flag.key] ? 'enabled' : 'disabled' }}</span>
        </span>
      </div>
      <p class="ia-reorder-controls__adjustment">Adjustment: {{ adjustmentSign }}{{ adjustmentPercent | percent }}</p>
    </div>
  </div>
</div>
